module.exports = __webpack_public_path__ + "img/check.bc31566b.svg";